/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchCMARecurringCostItemDto } from './PatchCMARecurringCostItemDto';
import {
    PatchCMARecurringCostItemDtoFromJSON,
    PatchCMARecurringCostItemDtoFromJSONTyped,
    PatchCMARecurringCostItemDtoToJSON,
    PatchCMARecurringCostItemDtoToJSONTyped,
} from './PatchCMARecurringCostItemDto';

/**
 * 
 * @export
 * @interface SubjectProperty
 */
export interface SubjectProperty {
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    mlsId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    mlsSource?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    addressLine1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    lotSizeSqFt?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    bathCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    bedCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    buildingName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    garageSpaces?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    hoaFeeCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    currentPrice?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof SubjectProperty
     */
    listDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    soldPrice?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof SubjectProperty
     */
    soldDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    livingAreaSqFt?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    neighborhood?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubjectProperty
     */
    styles?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    styleOther?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    typeOther?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    state?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    lat?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    lng?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    yearBuilt?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    zipCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    floor?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectProperty
     */
    hasDoormanAttendance?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubjectProperty
     */
    isLease?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof SubjectProperty
     */
    roomsTotal?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    flipTaxRemarks?: string | null;
    /**
     * 
     * @type {Array<PatchCMARecurringCostItemDto>}
     * @memberof SubjectProperty
     */
    recurringCosts?: Array<PatchCMARecurringCostItemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof SubjectProperty
     */
    listingStatus?: string | null;
}

/**
 * Check if a given object implements the SubjectProperty interface.
 */
export function instanceOfSubjectProperty(value: object): value is SubjectProperty {
    return true;
}

export function SubjectPropertyFromJSON(json: any): SubjectProperty {
    return SubjectPropertyFromJSONTyped(json, false);
}

export function SubjectPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectProperty {
    if (json == null) {
        return json;
    }
    return {
        
        'mlsId': json['mlsId'] == null ? undefined : json['mlsId'],
        'mlsSource': json['mlsSource'] == null ? undefined : json['mlsSource'],
        'addressLine1': json['addressLine1'] == null ? undefined : json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'lotSizeSqFt': json['lotSizeSqFt'] == null ? undefined : json['lotSizeSqFt'],
        'bathCount': json['bathCount'] == null ? undefined : json['bathCount'],
        'bedCount': json['bedCount'] == null ? undefined : json['bedCount'],
        'buildingName': json['buildingName'] == null ? undefined : json['buildingName'],
        'city': json['city'] == null ? undefined : json['city'],
        'description': json['description'] == null ? undefined : json['description'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'garageSpaces': json['garageSpaces'] == null ? undefined : json['garageSpaces'],
        'hoaFeeCents': json['hoaFeeCents'] == null ? undefined : json['hoaFeeCents'],
        'currentPrice': json['currentPrice'] == null ? undefined : json['currentPrice'],
        'listDate': json['listDate'] == null ? undefined : (new Date(json['listDate'])),
        'soldPrice': json['soldPrice'] == null ? undefined : json['soldPrice'],
        'soldDate': json['soldDate'] == null ? undefined : (new Date(json['soldDate'])),
        'livingAreaSqFt': json['livingAreaSqFt'] == null ? undefined : json['livingAreaSqFt'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'styles': json['styles'] == null ? undefined : json['styles'],
        'styleOther': json['styleOther'] == null ? undefined : json['styleOther'],
        'type': json['type'] == null ? undefined : json['type'],
        'typeOther': json['typeOther'] == null ? undefined : json['typeOther'],
        'state': json['state'] == null ? undefined : json['state'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'yearBuilt': json['yearBuilt'] == null ? undefined : json['yearBuilt'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'floor': json['floor'] == null ? undefined : json['floor'],
        'hasDoormanAttendance': json['hasDoormanAttendance'] == null ? undefined : json['hasDoormanAttendance'],
        'isLease': json['isLease'] == null ? undefined : json['isLease'],
        'roomsTotal': json['roomsTotal'] == null ? undefined : json['roomsTotal'],
        'flipTaxRemarks': json['flipTaxRemarks'] == null ? undefined : json['flipTaxRemarks'],
        'recurringCosts': json['recurringCosts'] == null ? undefined : ((json['recurringCosts'] as Array<any>).map(PatchCMARecurringCostItemDtoFromJSON)),
        'listingStatus': json['listingStatus'] == null ? undefined : json['listingStatus'],
    };
}

export function SubjectPropertyToJSON(json: any): SubjectProperty {
    return SubjectPropertyToJSONTyped(json, false);
}

export function SubjectPropertyToJSONTyped(value?: SubjectProperty | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mlsId': value['mlsId'],
        'mlsSource': value['mlsSource'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'lotSizeSqFt': value['lotSizeSqFt'],
        'bathCount': value['bathCount'],
        'bedCount': value['bedCount'],
        'buildingName': value['buildingName'],
        'city': value['city'],
        'description': value['description'],
        'notes': value['notes'],
        'garageSpaces': value['garageSpaces'],
        'hoaFeeCents': value['hoaFeeCents'],
        'currentPrice': value['currentPrice'],
        'listDate': value['listDate'] === null ? null : ((value['listDate'] as any)?.toISOString()),
        'soldPrice': value['soldPrice'],
        'soldDate': value['soldDate'] === null ? null : ((value['soldDate'] as any)?.toISOString()),
        'livingAreaSqFt': value['livingAreaSqFt'],
        'neighborhood': value['neighborhood'],
        'styles': value['styles'],
        'styleOther': value['styleOther'],
        'type': value['type'],
        'typeOther': value['typeOther'],
        'state': value['state'],
        'lat': value['lat'],
        'lng': value['lng'],
        'yearBuilt': value['yearBuilt'],
        'zipCode': value['zipCode'],
        'floor': value['floor'],
        'hasDoormanAttendance': value['hasDoormanAttendance'],
        'isLease': value['isLease'],
        'roomsTotal': value['roomsTotal'],
        'flipTaxRemarks': value['flipTaxRemarks'],
        'recurringCosts': value['recurringCosts'] == null ? undefined : ((value['recurringCosts'] as Array<any>).map(PatchCMARecurringCostItemDtoToJSON)),
        'listingStatus': value['listingStatus'],
    };
}

